// +----------------------------------------------------------------------
// | EB admin 店铺管理（由 view/admin/src/router/modules/merchant.js 转换）
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/setting';

const merchantRouter: RouteRecordRaw = {
  path: `${roterPre}/merchant`,
  name: 'merchant',
  meta: {
    icon: 'dashboard',
    title: '店铺管理',
  },
  alwaysShow: true,
  component: Layout,
  redirect: 'noRedirect',
  children: [
    {
      path: 'system',
      name: 'MerchantSystem',
      meta: {
        title: '店铺权限管理',
        noCache: true,
      },
      component: () => import('@/views/merchant/system/index.vue'),
    },
    {
      path: 'list',
      name: 'MerchantList',
      meta: {
        title: '店铺列表',
        noCache: true,
      },
      component: () => import('@/views/merchant/list/index.vue'),
    },
    {
      path: 'list/reconciliation/:id/:type?',
      name: 'MerchantRecord',
      component: () => import('@/views/merchant/list/record.vue'),
      meta: {
        title: '店铺对账',
        noCache: true,
        activeMenu: `${roterPre}/merchant/list`,
      },
      hidden: true,
    },
    {
      path: 'classify',
      name: 'MerchantClassify',
      meta: {
        title: '店铺分类',
        noCache: true,
      },
      component: () => import('@/views/merchant/classify/index.vue'),
    },
    {
      path: 'index',
      name: 'MerchantIndex',
      meta: {
        title: '商户列表',
        noCache: true,
      },
      component: () => import('@/views/merchant/index.vue'),
    },
    {
      path: 'create',
      name: 'MerchantCreate',
      meta: {
        title: '创建商户',
        activeMenu: `${roterPre}/merchant/index`,
        noCache: true,
      },
      component: () => import('@/views/merchant/create.vue'),
    },
    {
      path: 'admin-list',
      name: 'MerchantAdminList',
      meta: {
          title: '商户管理员',
          noCache: true
      },
      component: () => import('@/views/merchant/application/admin-list.vue')
    },

    {
      path: 'application',
      name: 'MerchantApplication',
      meta: {
        title: '店铺申请',
        noCache: true,
      },
      component: () => import('@/views/merchant/application/index.vue'),
    },



      {
          path: 'agree',
          name: 'MerchantAgreement',
          meta: {
              title: '入驻协议',
              noCache: true
          },
          component: () => import('@/views/merchant/agreement/index.vue')
      },

      {
          path: 'type',
          name: 'storeType',
          meta: {
              title: '店铺类型',
              noCache: true
          },
          component: () => import('@/views/merchant/type/index.vue')
      },

      {
          path: 'applyMents',
          name: 'MerchantApplyMents',
          meta: {
              title: '服务申请',
              noCache: true
          },
          component: () => import('@/views/merchant/applyments/index.vue')
      },
      {
          path: 'applyList',
          name: 'ApplyList',
          meta: {
              title: '分账店铺列表'
          },
          component: () => import('@/views/merchant/applyments/list.vue')
      },
      {
          path: 'type/description',
          name: 'MerTypeDesc',
          meta: {
              title: '店铺类型说明',
              noCache: true,
          },
          component: () => import('@/views/merchant/type/description.vue')
      },
      {
          path: 'deposit_list',
          name: 'DepositList',
          meta: {
              title: '店铺保证金管理',
              noCache: true
          },
          component: () => import('@/views/merchant/deposit/index.vue')
      },
      {
          path: 'recharge_record',
          name: 'MerRechargeRecord',
          meta: {
              title: '店铺充值记录',
              noCache: true
          },
          component: () => import('@/views/merchant/rechargeRecord/index.vue')
      },
    {
      path: 'grouping',
      name: 'MerchantGrouping',
      meta: {
        title: '店铺分组',
        noCache: true,
      },
      component: () => import('@/views/merchant/grouping/index.vue'),
    },
    {
          path: 'grouping/create',
          name: 'MerchantGroupingCreate',
          meta: {
              title: '创建店铺分组',
              activeMenu: `${roterPre}/merchant/grouping`,
              noCache: true
          },
          component: () => import('@/views/merchant/grouping/create.vue')
     },
     {
          path: "review",
          name: "MerchantReview",
          meta: {
              title: '商户入驻审核',
              noCache: true
          },
          component: () => import('@/views/merchant/application/review.vue')
      },
      {
          path: "apply-setting",
          name: "MerchantApplySetting",
          meta: {
              title: '商户设置',
              noCache: true
          },
          component: () => import('@/views/merchant/application/apply-setting.vue')
      }
  ],
};

export default merchantRouter;
